import * as types from "./../../../types/stores.types";

const initialState = {
    statusShow: false,
    discountCode: '',
    statusLoader: false,
    statusSet: false,

    max_discount_price: null,
    amount: null,

    result_discount:0,

    my_codes:[]
};
const modalAddDiscountCode = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_HANDLE_MODAL_ADD_DISCOUNT_CODE':
            return {...state, statusShow: action.statusShow};
        case 'CHANGE_INPUTS_MODAL_ADD_DISCOUNT_CODE':
            return {...state, [action.name]: action.value};
        case types.PUT_SET_DISCOUNTS_CODES:
            return {...state,my_codes: action.payload.codes};
        case 'REFRESH_MODAL_ADD_DISCOUNT_CODE':
            return initialState;
        default:
            return state;
    }
};

export default modalAddDiscountCode;